import * as angular from "angular";
import {CommonsService} from "../commons/services/commons-service.service";
import {VisitPlanFacadeService} from "./angular/services/visit-plan-facade.service";
import {firstValueFrom, lastValueFrom} from "rxjs";
import * as moment from "moment";
import {VisitPlanScheduleFacadeService} from "./angular/services/visit-plan-schedule-facade.service";
import {VisitPlanHttpService} from "./angular/services/visit-plan-http.service";
import {VisitScheduleFacadeService} from "./angular/services/visit-schedule-facade.service";
import {ViewFilterSettingsService} from "../commons/services/view-filter-settings.service";
import {VisitPlanFilterSettingsService} from "./services/visit-plan-filter-settings.service";

angular
  .module('bringoz.admin.scheduling-project')
  .config(SchedulingProjectConfig);


/* @ngInject */
function SchedulingProjectConfig($stateProvider) {
  $stateProvider

    .state('scheduling-project', {
      parent: 'bringoz.site',
      abstract: true,
      url: '/scheduling-project',
      template: '<ui-view></ui-view>',
      controller: function (site) {
      }
    })

    .state('scheduling-project.visit-plans', {
      url: '/visit-plans',
      controllerAs: 'vm',
      abstract: true,
      template: '<scheduling-project-visit-plan-view></scheduling-project-visit-plan-view>',
      controller: function ($stateParams, commonsService: CommonsService, site) {
      }
    })

    .state('scheduling-project.visit-plans.calendar', {
      url: '/calendar?:branchIds&:groupIds&:tags&:serviceAreaIds&:statuses&:templateIds&:from&:to&:schedulingProjectStatuses&:isArchive&:createdByCurrentUser',
      controllerAs: 'vm',
      template: '<scheduling-project-visit-plan-calendar-view' +
        ' branch-ids="vm.branchIds"' +
        ' group-ids="vm.groupIds"' +
        ' tags="vm.tags"' +
        ' service-area-ids="vm.serviceAreaIds"' +
        ' statuses="vm.statuses" ' +
        ' template-ids="vm.templateIds" ' +
        ' from="vm.from" ' +
        ' to="vm.to"' +
        ' scheduling-project-statuses="vm.schedulingProjectStatuses"' +
        ' is-archive="vm.isArchive"' +
        ' created-by-current-user="vm.createdByCurrentUser">' +
        '</scheduling-project-visit-plan-calendar-view>',
      controller: function (triBreadcrumbsService, $stateParams, commonsService: CommonsService,
                            visitPlanFilterSettingsService: VisitPlanFilterSettingsService, site) {

        const savedFilters = visitPlanFilterSettingsService.getFilters();

        // this.visitPlans = visitPlans;
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || savedFilters?.branchIds || [];
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || savedFilters?.groupIds || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || savedFilters?.tags || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || savedFilters?.serviceAreaIds || [];
        this.statuses = commonsService.parseArrayStateParam($stateParams.statuses) || savedFilters?.statuses || [];
        this.templateIds = commonsService.parseArrayStateParam($stateParams.templateIds) || savedFilters?.templateIds || [];
        this.schedulingProjectStatuses = commonsService.parseArrayStateParam($stateParams.schedulingProjectStatuses) || savedFilters?.schedulingProjectStatuses || [];
        this.from = $stateParams.from ? parseInt($stateParams.from) : (savedFilters?.from || moment().startOf('month').valueOf());
        this.to = $stateParams.to ? parseInt($stateParams.to) : (savedFilters?.to || moment().endOf('month').valueOf());
        this.isArchive = $stateParams.isArchive != null ? ($stateParams.isArchive === 'true' || $stateParams.isArchive === true) : (savedFilters?.isArchive || false);
        this.createdByCurrentUser = $stateParams.createdByCurrentUser != null ? JSON.parse($stateParams.createdByCurrentUser) : (savedFilters?.createdByCurrentUser ?? true);


        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Calendar"});
        triBreadcrumbsService.addCrumb({name: "Scheduling Project"});
      },
      // resolve: {
      //   visitPlans: function (visitPlanFacadeService: VisitPlanFacadeService, $stateParams, commonsService: CommonsService, site) {
      //     const params = {
      //       branchIds: $stateParams.branchIds ? commonsService.parseArrayStateParam($stateParams.branchIds) : [],
      //       serviceAreaIds: $stateParams.serviceAreaIds ? commonsService.parseArrayStateParam($stateParams.serviceAreaIds) : [],
      //       statuses: $stateParams.statuses ? commonsService.parseArrayStateParam($stateParams.statuses) : [],
      //       schedulingProjectStatuses: $stateParams.schedulingProjectStatuses ? commonsService.parseArrayStateParam($stateParams.schedulingProjectStatuses) : [],
      //       from: $stateParams.from ? parseInt($stateParams.from) : moment().startOf('month').valueOf(),
      //       to: $stateParams.to ? parseInt($stateParams.to) : moment().endOf('month').valueOf(),
      //       size: 100
      //     };
      //     return visitPlanFacadeService.getMany(params)
      //   }
      // }
    })

    .state('scheduling-project.visit-plans.table', {
      url: '/table?:branchIds&:groupIds&:tags&:serviceAreaIds&:statuses&:templateIds&:from&:to&:schedulingProjectStatuses&:isArchive&:createdByCurrentUser',
      controllerAs: 'vm',
      template: '<scheduling-project-visit-plan-table-view' +
        ' branch-ids="vm.branchIds"' +
        ' group-ids="vm.groupIds"' +
        ' tags="vm.tags"' +
        ' service-area-ids="vm.serviceAreaIds"' +
        ' statuses="vm.statuses" ' +
        ' template-ids="vm.templateIds" ' +
        ' from="vm.from" ' +
        ' to="vm.to"' +
        ' scheduling-project-statuses="vm.schedulingProjectStatuses"' +
        ' is-archive="vm.isArchive"' +
        ' created-by-current-user="vm.createdByCurrentUser">' +
        '</scheduling-project-visit-plan-table-view>',
      controller: function (triBreadcrumbsService, $stateParams, commonsService: CommonsService,
                            visitPlanFilterSettingsService: VisitPlanFilterSettingsService, site) {
        const savedFilters = visitPlanFilterSettingsService.getFilters();

        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || savedFilters?.branchIds || [];
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || savedFilters?.groupIds || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || savedFilters?.tags || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || savedFilters?.serviceAreaIds || [];
        this.statuses = commonsService.parseArrayStateParam($stateParams.statuses) || savedFilters?.statuses || [];
        this.templateIds = commonsService.parseArrayStateParam($stateParams.templateIds) || savedFilters?.templateIds || [];
        this.schedulingProjectStatuses = commonsService.parseArrayStateParam($stateParams.schedulingProjectStatuses) || savedFilters?.schedulingProjectStatuses || [];
        this.from = $stateParams.from ? parseInt($stateParams.from) : moment().subtract(6, 'months').startOf('day').valueOf();
        this.to = $stateParams.to ? parseInt($stateParams.to) : moment().add(6, 'months').endOf('day').valueOf();
        this.isArchive = $stateParams.isArchive != null ? ($stateParams.isArchive === 'true' || $stateParams.isArchive === true) : (savedFilters?.isArchive || false);
        this.createdByCurrentUser = $stateParams.createdByCurrentUser != null ? JSON.parse($stateParams.createdByCurrentUser) : (savedFilters?.createdByCurrentUser ?? true);

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Table"});
        triBreadcrumbsService.addCrumb({name: "Scheduling Project"});
      }
    })


    .state('scheduling-project.visit-plans.templates', {
      url: '/templates',
      controllerAs: 'vm',
      template: '<scheduling-project-visit-plan-templates-view></scheduling-project-visit-plan-templates-view>',
      controller: function (triBreadcrumbsService) {
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Templates"});
        triBreadcrumbsService.addCrumb({name: "Scheduling Project"});
      }
    })

    .state('scheduling-project.visit-plans.reports', {
      url: '/reports?:branchIds&:groupIds&:tags&:serviceAreaIds&:statuses&:from&:schedulingProjectStatuses&:isArchive',
      controllerAs: 'vm',
      template: '<scheduling-project-reports-view' +
        ' branch-ids="vm.branchIds"' +
        ' group-ids="vm.groupIds"' +
        ' tags="vm.tags"' +
        ' service-area-ids="vm.serviceAreaIds"' +
        ' statuses="vm.statuses" from="vm.from"' +
        ' scheduling-project-statuses="vm.schedulingProjectStatuses"' +
        ' is-archive="vm.isArchive">' +
        '</scheduling-project-reports-view>',
      controller: function (triBreadcrumbsService, $stateParams, commonsService: CommonsService) {
        this.branchIds = commonsService.parseArrayStateParam($stateParams.branchIds) || [];
        this.groupIds = commonsService.parseArrayStateParam($stateParams.groupIds) || [];
        this.tags = commonsService.parseArrayStateParam($stateParams.tags) || [];
        this.serviceAreaIds = commonsService.parseArrayStateParam($stateParams.serviceAreaIds) || [];
        this.statuses = commonsService.parseArrayStateParam($stateParams.statuses) || [];
        this.schedulingProjectStatuses = commonsService.parseArrayStateParam($stateParams.schedulingProjectStatuses) || [];
        this.from = $stateParams.from ? parseInt($stateParams.from) : moment().valueOf();
        this.isArchive = $stateParams.isArchive === 'true' || $stateParams.isArchive === true;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Reports"});
        triBreadcrumbsService.addCrumb({name: "Scheduling Project"});
      }
    })


    .state('scheduling-project.visit-plan', {
      url: '/visit-plan/:id?:visitScheduleSize&:visitSchedulePage',
      controllerAs: 'vm',
      template: '<visit-plan-view ' +
        'visit-plan-id="vm.visitPlanId" ' +
        'selected-quick-filter-id="vm.selectedQuickFilterId" ' +
        'visit-schedule-page="vm.visitSchedulePage" ' +
        'visit-schedule-size="vm.visitScheduleSize"></visit-plan-view>',
      controller: function (triBreadcrumbsService, $stateParams, visitPlan, visitSchedule, visitPlanFacadeService: VisitPlanFacadeService,
                            $state, visitScheduleFacadeService: VisitScheduleFacadeService, viewFilterSettingsService: ViewFilterSettingsService, site) {

        visitPlanFacadeService.setOne(visitPlan, true);
        visitScheduleFacadeService.setOne(visitSchedule, true);
        this.visitPlanId = $stateParams.id;
        // this.routes = visitPlanRoutes?.list || [];

        this.visitSchedulePage = $stateParams.page ? parseInt($stateParams.page) : 0;
        this.visitScheduleSize = $stateParams.size ? parseInt($stateParams.size) : 50;

        const quickActiveFilter = viewFilterSettingsService.getActiveQuickFilter($state.current.name);
        this.selectedQuickFilterId = quickActiveFilter?.id;

        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: visitPlan.name + ' (' + visitPlan.zoneId + ')'});
        triBreadcrumbsService.addCrumb({name: "Visit Plan"});
        triBreadcrumbsService.addCrumb({name: "Scheduling Project", state: 'scheduling-project.visit-plans.table'});
      },
      resolve: {
        visitPlan: function ($stateParams, visitPlanFacadeService: VisitPlanFacadeService, site) {
          return firstValueFrom(visitPlanFacadeService.getVisitPlan($stateParams.id));
        },
        // visitPlanRoutes: function (visitPlanHttpService: VisitPlanHttpService, visitPlan) {
        //   if (visitPlan.scheduleStatus === 'PLANNED') {
        //     const routesQuery = {
        //       limit: 3000
        //     }
        //     return firstValueFrom(visitPlanHttpService.getVisitScheduleRoutesCursor(visitPlan.id, visitPlan.scheduleId, routesQuery))
        //   }
        //   return undefined;
        // },
        visitSchedule: function (visitPlan, visitPlanHttpService: VisitPlanHttpService, site) {
          return firstValueFrom(visitPlanHttpService.getVisitSchedule(visitPlan.id, visitPlan.scheduleId));
        },
      }
    })


}
